import { FeedbackRating } from "../../skjema/feedback/Feedback.types";
import feedback_nb from "../nb/feedback";

const feedback: typeof feedback_nb = {
  header: "Korleis var opplevinga di med å fylla inn dette skjemaet?",
  input: {
    beskrivelse: {
      label: "Kan du seia litt om kvifor? (valfritt)",
      helpText:
        "Ikkje skriv personleg informasjon som namn, fødselsnummer eller kontaktopplysningar, men bruk gjerne konkrete døme på utfordringar du har opplevd",
    },
  },
  button: {
    send: "Send tilbakemelding",
  },
  validering: {
    maxLength: "Beskrivinga kan ikkje vera lengre enn 250 teikn",
  },
  emoji: {
    "5": "Super!",
    "4": "Bra",
    "3": "Ok",
    "2": "Ikkje bra",
    "1": "Dårleg",
  } satisfies Record<FeedbackRating, string>,
  alert: {
    success: {
      header: "Tusen takk for tilbakemeldinga",
      message: "Innspela dine hjelper oss med å gjera tenesta betre!",
    },
    failure: {
      header: "Noko gjekk gale",
      message:
        "Me har dessverre ikkje teke imot tilbakemeldinga di. Forsøk gjerne å senda inn på nytt og takk for at du tok deg tid til å svara!",
    },
  },
};
export default feedback;
